import { StepType, useTour } from '@reactour/tour';
import { useLocation } from 'react-router-dom';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';
import { useProvider } from 'utils/providers/Provider';

const useGetViewCreatedLeads = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;
  const { pathname } = useLocation();

  const isInLeadsPage = pathname.includes('leads');

  const viewCreatedLeadsSteps: StepType[] = [
    ...(!isInLeadsPage
      ? ([
          {
            content: 'Go to the Contacts menu tab.',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.MENU}"]`,
            position: 'right',
            action: (node: any) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(1), 200);
                },
                false,
              );
            },
          },
        ] as StepType[])
      : []),
    ...(!isInLeadsPage
      ? ([
          {
            content: 'Then select Leads to view the Leads page.',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.SUBMENU}"]`,
            position: 'right',
            action: (node: any) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(2), 200);
                },
                false,
              );
            },
          },
        ] as StepType[])
      : []),
    {
      content: (props) => (
        <Content
          content="On this page you can view all your created Lead contacts."
          {...props}
          hideNote
          endTour
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.MANAGE.TABLE}"]`,
      position: 'top',
      stepInteraction: false,
      padding: {
        popover: [4, 8],
      },
    },
  ];

  const showViewCreatedLeadsSteps = () => {
    if (isCollapsed && !isInLeadsPage) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(viewCreatedLeadsSteps);
      setIsOpen(true);
    }, 300);
  };

  return showViewCreatedLeadsSteps;
};

export default useGetViewCreatedLeads;
